import { Search } from 'lucide-react'

const KIND_LABELS = { decouverte: 'Découverte', bilan_annuel: 'Bilan annuel', suivi: 'Suivi', recommandation: 'Recommandation' }
const STATE_LABELS = { recording: 'En cours', processing: 'Traitement', ready: 'Prêt', signed: 'Signé', aborted: 'Interrompue' }

function ChipGroup({ label, options, selected, onToggle }) {
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      <span className="text-[11px] uppercase tracking-[1.2px] text-muted">{label}</span>
      {Object.entries(options).map(([k, lbl]) => {
        const isOn = selected.includes(k)
        return (
          <button
            key={k}
            onClick={() => onToggle(k)}
            className={`rounded-full border px-2.5 py-1 text-[11.5px] transition-colors ${
              isOn ? 'border-terra-500 bg-terra-50 text-terra-700' : 'border-line bg-white text-muted hover:border-terra-500/50'
            }`}
          >
            {lbl}
          </button>
        )
      })}
    </div>
  )
}

export default function SessionsToolbar({
  query, onQueryChange,
  kinds, onToggleKind,
  states, onToggleState,
  groupByClient, onToggleGroupByClient,
}) {
  return (
    <div className="mb-5 space-y-3">
      <div className="flex items-center gap-2 rounded-lg border border-line bg-white px-3 py-2">
        <Search size={14} className="text-muted" />
        <input
          type="text"
          value={query}
          onChange={(e) => onQueryChange(e.target.value)}
          placeholder="Rechercher par nom de client…"
          className="flex-1 bg-transparent text-[13.5px] outline-none"
        />
      </div>
      <ChipGroup label="Type" options={KIND_LABELS} selected={kinds} onToggle={onToggleKind} />
      <ChipGroup label="État" options={STATE_LABELS} selected={states} onToggle={onToggleState} />
      <div className="flex justify-end">
        <button
          onClick={() => onToggleGroupByClient(!groupByClient)}
          className={`rounded-full border px-3 py-1 text-[11.5px] ${
            groupByClient ? 'border-terra-500 bg-terra-50 text-terra-700' : 'border-line bg-white text-muted'
          }`}
        >
          Grouper par client
        </button>
      </div>
    </div>
  )
}
